import type { JSX } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';
import type { SelectableCandidate } from '../../hooks/useCandidateFilter';

interface CandidateSelectorDropdownProps {
  filtered: SelectableCandidate[];
  availableCount: number;
  selectedCandidateId: string | null;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSelect: (value: string) => void;
}

export function CandidateSelectorDropdown({
  filtered,
  availableCount,
  selectedCandidateId,
  searchValue,
  onSearchChange,
  onSelect,
}: CandidateSelectorDropdownProps): JSX.Element {
  return (
    <Command shouldFilter={false}>
      <CommandInput
        placeholder="Search by name or email..."
        value={searchValue}
        onValueChange={onSearchChange}
      />
      <CommandList>
        <CommandEmpty>
          <p className="py-6 text-center text-sm text-muted-foreground">
            {availableCount === 0 ? 'No candidates available.' : 'No candidates found.'}
          </p>
        </CommandEmpty>
        <CommandGroup>
          {filtered.map((c) => (
            <CommandItem key={c.id} value={c.id} onSelect={onSelect}>
              <Check
                className={cn(
                  'mr-2 h-4 w-4',
                  selectedCandidateId === c.id ? 'opacity-100' : 'opacity-0'
                )}
              />
              <div className="flex flex-col">
                <span className="font-medium">{c.name}</span>
                <span className="text-xs text-muted-foreground">{c.email}</span>
              </div>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
